import React, { useEffect } from "react";
import email from "../../../assets/media/icon/email.svg";
import "./index.css";
import { useNavigate } from "react-router";
const ResetPassword = () => {
  useEffect(() => {
    document.title = "Snilink - Reset password";
  }, []);
  const Nav = useNavigate();
  return (
    <>
      <section className="login-page">
        <div className="login-page-content">
          <div className="login-page-container">
            <h1>Reset password</h1>
            <p>No worries, we'll send you rest instructions</p>
            <div className="labled-input pb">
              <label>Email</label>
              <div className="iconed-input">
                <div className="icon">
                  <img src={email} alt="" />
                </div>
                <input type="text" placeholder="you@email.com" />
              </div>
            </div>
            <button className="primary-btn">Receive email</button>
            <button
              onClick={() => {
                Nav("/login");
              }}
              className="secondary-btn"
            >
              Back to login
            </button>
          </div>
        </div>
      </section>
    </>
  );
};
export default ResetPassword;
